module.exports = __webpack_public_path__ + "static/img/no.59fc5b9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no.png
// module id = nP1P
// module chunks = 1